// const API_URL = process.env.REACT_APP_API_URL;

const API_URL = process.env.REACT_APP_API_URL;

export async function getCollegeData() {
  let data = [];
  try {
    const res = await fetch(`${API_URL}/api/students/colleges-with-branches`);

    if (!res.ok) throw Error("Failed getting menu");
    if (res.ok) {
      data = await res.json();
    }
  } catch (error) {
    console.error("Error fetching college data:", error);
  }

  return data;
}

export async function loginUser(credentials) {
  const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
      credentials: 'include',
  });

  // Parse JSON response
  const data = await response.json();

  if (response.ok) {
      return data;  // Return parsed JSON response
  } else {
      return data;  // Return error message in JSON format
  }
}

export const logout = async () => {
  try {
      const response = await fetch(`${API_URL}/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
      });

      if (response.ok) {
          return { success: true, message: 'Logout successful' };
      } else {
          return { success: false, error: 'Logout failed' };
      }
  } catch (error) {
      return { success: false, error: 'Something went wrong, please try again later' };
  }
};


export async function sendEmailToUserForPasswordReset(email) {
  const response = await fetch(`${API_URL}/auth/reset-password?email=${email}`, { // Email in query parameter
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to send password reset email');
  }

  return response; // Return the response data
};

export async function sendPasswordEmailToAllUsers() { // apna
  const response = await fetch(`${API_URL}/auth/email-password-to-all-users`, { // Email in query parameter
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to send password reset email');
  }

  return response.data; // Return the response data
};

export const updateUserPassword = async (email, currentPassword, newPassword) => {
  const response = await fetch(`${API_URL}/auth/update-password?email=${encodeURIComponent(email)}&currentPassword=${encodeURIComponent(currentPassword)}&newPassword=${encodeURIComponent(newPassword)}`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
  });

  return response; // Return the response for handling in the component
};

export async function isAuthenticated() {
  const response = await fetch(`${API_URL}/auth/status`, {
      method: 'GET',
      credentials: 'include', // Include cookies in the request
  });

  if (!response.ok) {
    return { status: "false", role: 'error' };
  }

  const responseData = await response.json(); // Assuming the response is a boolean
  return responseData;
}

export const fetchStudentData = async () => {
  try{
    const response = await fetch(`${API_URL}/student/profile`,{
      credentials: 'include'
    });

    if(!response.ok){
      throw new Error (`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data; // return the data for use in the component
  }
  catch(error) {
     console.error("Error fetching student data:", error);
     throw error;
  }
};


export const fetchStudentRegistrations = async () => {
  try {
    const response = await fetch(`${API_URL}/admin/students/details`, {
      credentials: "include",
    });
    if(!response.ok) {
      throw new Error(`HTTP error! Status : ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchCollegesList = async () => {
  try{
    const response = await fetch(`${API_URL}/api/colleges`);

    if(!response.ok){
      throw new Error (`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data; // return the data for use in the component
  }
  catch(error) {
     console.error("Error fetching student data:", error);
     throw error;
  }
};


export const fetchApprovedEmails = async () => {
  try {
    const response = await fetch(`${API_URL}/api/approved-emails`, {
      method: "GET",
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch emails: ${response.statusText}`);
    }

    return await response.json(); // Ensure the API returns emails with collegeId
  } catch (error) {
    console.error("Error fetching emails:", error);
    throw error;
  }
};



export const fetchStudentLearningTracks = async (id) => {
  try {
    const response = await fetch(`${API_URL}/api/student-learning-tracks/${id}`,{credentials: 'include',});
    
    const rawResponse = await response.text(); // Fetch raw response
    console.log("Raw Response:", rawResponse);

    if (!response.ok) {
      throw new Error("Failed to fetch learning tracks");
    }
    return JSON.parse(rawResponse);
  } catch (error) {
    console.error("Error fetching learning tracks:", error);
    throw error;
  }
};

export const fetchLearningTracks = async () => {
  try {
    const response = await fetch(`${API_URL}/api/learning-tracks`,{credentials: 'include',});

    if (!response.ok) {
      throw new Error("Failed to fetch learning tracks");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching learning tracks:", error);
    throw error;
  }
};


export async function assignTrackToStudent(studentId, trackId) {
    const response = await fetch(`${API_URL}/api/student-learning-tracks/${studentId}/assign/${trackId}`, {

      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      
      credentials: 'include',
  });

  // Parse JSON response
  const data = await response.json();

  if (response.ok) {
      return data;  // Return parsed JSON response
  } else {
      return data;  // Return error message in JSON format
  }
}

// Add bulk emails
export const addBulkEmails = async (emailArray, collegeId) => {
  try {
    const response = await fetch(`${API_URL}/api/approved-emails/bulk-add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ emails: emailArray, collegeId }), // Send collegeId
      credentials: 'include',
    });

    if (!response.ok) {
      console.log("if not ok",response)
      throw new Error("Failed to add emails");
    }

    console.log(response)

    return await response.json(); // Parse JSON response
  } catch (error) {
    console.error("Error adding bulk emails:", error);
    throw error;
  }
};


// Delete an email (Requires email & collegeId)
export const deleteEmail = async (email, collegeId) => {
  try {
    const response = await fetch(`${API_URL}/api/approved-emails/${email}/${collegeId}`, {
      method: "DELETE",
      credentials: "include", // Ensuring authentication if needed
    });

    if (!response.ok) {
      throw new Error(`Failed to delete email: ${response.statusText}`);
    }

    return await response.text(); // API returns a plain string response
  } catch (error) {
    console.error("Error deleting email:", error);
    throw error;
  }
};
export async function sendCollegeAndCoordinatorDetails(collegeAndCoordinatorDetails) {
  const response = await fetch(`${API_URL}/admin/collegeAndCoordinatorDetails`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(collegeAndCoordinatorDetails),
      credentials: 'include',
  });

  // Parse JSON response
  const data = await response.json();

  if (response.ok) {
      return data;  // Return parsed JSON response
  } else {
      return data;  // Return error message in JSON format
  }
}

export const fetchCodingProfiles = async (studentId) => {
  try {
    const response = await fetch(`${API_URL}/api/codingProfiles/student/${studentId}`, {
      method: "GET",
      credentials: 'include',
    });
    if (!response.ok) throw new Error("Failed to fetch coding profiles");
    return await response.json();
  } catch (error) {
    console.error("Error fetching coding profiles:", error);
    throw error;
  }
};

// Create or update platform
export const saveCodingProfile = async (platformData) => {
  try {
    const response = await fetch(`${API_URL}/api/codingProfiles`, {
      method: "POST", // Change to PUT if updating an existing record
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(platformData),
      credentials: 'include',
    });
    if (!response.ok) throw new Error("Failed to save platform");
    return await response.json();
  } catch (error) {
    console.error("Error saving platform:", error);
    throw error;
  }
};

export const getCollegeProgramDates = async (collegeId) => {
  try{
  const response = await fetch(`${API_URL}/api/colleges/${collegeId}/program-dates`, {
      method: "GET",
      credentials: 'include',
    });
  if (!response.ok) {
    throw new Error(`Failed to fetch program dates: ${response.status}`);
  }
  return await response.json();
   } catch (error) {
    console.error("Error fetching total coding problems:", error);
    throw error;
  }
  
};

export const fetchTotalProblemsSolved = async (studentId) => {
  try{
  const response = await fetch(`${API_URL}/api/codingProfiles/student/${studentId}/totalProblemsSolved`, {
      method: "GET",
      credentials: 'include',
    });
  if (!response.ok) {
    throw new Error("Failed to fetch total problems solved");
  }
  return await response.json();
  } catch (error) {
    console.error("Error fetching total coding problems:", error);
    throw error;
  }
};


// Delete platform
export const deleteCodingProfile = async (profileId) => {
  try {
    const response = await fetch(`${API_URL}/api/codingProfiles/${profileId}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (!response.ok) throw new Error("Failed to delete platform");
    return await response.json();
  } catch (error) {
    console.error("Error deleting platform:", error);
    throw error;
  }
};

// Fetch all certificates for a specific student
export const fetchStudentCertificates = async (studentId) => {
  try {
    const response = await fetch(`${API_URL}/api/certificates/student/${studentId}`, {
      method: "GET",
      credentials: "include",
    });
    if (!response.ok) throw new Error("Failed to fetch student certificates");
    return await response.json();
  } catch (error) {
    console.error("Error fetching student certificates:", error);
    throw error;
  }
};

// Add a new certificate for a student
export const addStudentCertificate = async (studentId, certificateData) => {
  try {
    const response = await fetch(`${API_URL}/api/certificates/student/${studentId}`, {
      method: "POST",
      body: certificateData,
      credentials: "include",
      
    });
    if (!response.ok) throw new Error("Failed to add student certificate");
    return await response.json();
  } catch (error) {
    console.error("Error adding student certificate:", error);
    throw error;
  }
};


// Add a new certificate for a student
export const updateStudentCertificate = async (studentId,certificateId, certificateData) => {
  try {
    const response = await fetch(`${API_URL}/api/certificates/student/${studentId}/certificate/${certificateId}`, {
      method: "PUT",
      body: certificateData,
      credentials: "include",
      
    });
    if (!response.ok) throw new Error("Failed to update certificate");
    return await response.json();
  } catch (error) {
    console.error("Error updating certificate:", error);
    throw error;
  }
};

// Delete a certificate by ID
export const deleteStudentCertificate = async (certificateId) => {
  try {
    const response = await fetch(`${API_URL}/api/certificates/${certificateId}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (!response.ok) throw new Error("Failed to delete student certificate");
    return await response.json();
  } catch (error) {
    console.error("Error deleting student certificate:", error);
    throw error;
  }
};

// API function to upload a file
export const uploadFile = async (file,teamId) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await fetch(`${API_URL}/api/ppt-submission/${teamId}`, {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      throw new Error("File upload failed");
    }
    const data = await response.json();
    console.log("File uploaded successfully:", data);
    return data;
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};

// API function to get the uploaded file
export const getUploadedFile = async (teamId) => {
  try {
    const response = await fetch(`${API_URL}/api/ppt-submission/${teamId}`, {
      method: "GET",
    });

   
    
    if (!response.ok) {
      throw new Error("Error fetching file");
    }
    // const data = await response.json();
    const url = await response.text();
    console.log("response is :",url);
    return url;
  } catch (error) {
    console.error("Error fetching uploaded file:", error);
  }
};



export const getProjectDetails = async (teamId) => {
  try {
    const response = await fetch(`${API_URL}/api/teams/${teamId}/project`, {
      method: 'GET',
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error in getProjectDetails:', error);
    throw error;
  }
};

export const getMentors = async (teamId) => {
  try {
    const response = await fetch(`${API_URL}/api/team-mentors/team/${teamId}`, {
      method: 'GET',
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error in getProjectDetails:', error);
    throw error;
  }
};

export const getCollegeList = async () => {
  try {
    const response = await fetch(`${API_URL}/api/college-registrations/colleges`, {
      method: 'GET',
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error in getCollegeList:', error);
    throw error;
  }
};

export const getStudentListByCollege = async (collegeId) => {
  try {
    const response = await fetch(`${API_URL}/college/${collegeId}/without-team`, {
      method: 'GET',
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error in getStudentListByCollege:', error);
    throw error;
  }
};

export const getMentorsListByCollege = async (collegeId) => {
  try {
    const response = await fetch(`${API_URL}/api/mentors/college/${collegeId}`, {
      method: 'GET',
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error in getMentorsListByCollege:', error);
    throw error;
  }
};

export const getAgivantMentorsList = async () => {
  try {
    const response = await fetch(`${API_URL}/api/mentors/agivant`, {
      method: 'GET',
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error in getMentorsListByCollege:', error);
    throw error;
  }
};

export const createTeam = async (teamName, studentIds) => {
  try {
    const response = await fetch(`${API_URL}/api/teams`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        teamName: teamName,
        studentIds: studentIds
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create team');
    }

    const data = await response.json();
    console.log('Team created:', data); // You can log the response here to see the returned data
    return data; // Return the created team data (could be the teamId, etc.)
  } catch (error) {
    console.error('Error creating team:', error);
    throw error;
  }
};

// Create or update project
export const saveProject = async (projectData) => {
  try {
    const response = await fetch(`${API_URL}/api/projects`, {
      method: "POST", // Change to PUT if updating an existing record
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(projectData),
      credentials: 'include',
    });
    if (!response.ok) throw new Error("Failed to save project");
    return await response.json();
  } catch (error) {
    console.error("Error saving platform:", error);
    throw error;
  }
};

// API call to save a single mentor
export const saveMentors = async (mentorDetails) => {
  try {
    const response = await fetch(`${API_URL}/api/mentors/institute`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mentorDetails),
    });
 
    if (!response.ok) {
      throw new Error("Failed to save mentor");
    }
 
    const data = await response.json();
    return data;  // Return the saved mentor data or a success message
  } catch (error) {
    console.error("Error saving mentor:", error);
    throw error;  // Rethrow the error to be handled in the component
  }
};

// API call to save a single mentor
export const saveMentorIdTeamId = async (teamId, mentorId,agivantMentorId) => {
  try {
    const response = await fetch(`${API_URL}/api/team-mentors/team_mentorId_teamId?teamId=${teamId}&mentorId=${mentorId}&agivantMentorId=${agivantMentorId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        teamId: teamId,
        mentorId: mentorId
      }),
    });
 
    if (!response.ok) {
      throw new Error("Failed to save mentorId and teamId");
    }
 
    const data = await response.json();
    return data;  // Return the saved mentor data or a success message
  } catch (error) {
    console.error("Error saving mentorId and teamId:", error);
    throw error;  // Rethrow the error to be handled in the component
  }
};

export const deleteProjectById = async (projectId) => {
  try {
    const response = await fetch(`${API_URL}/api/projects/${projectId}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error("Failed to delete project");
    }

    // No need to parse JSON since it's an empty response body
    return; // Project deleted successfully
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};


export const fetchProjects = async () => {
  try {
    const response = await fetch(`${API_URL}/api/projects`);

    if (!response.ok) {
      throw new Error("Failed to fetch projects");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};



// Mark as complete
export const markAsComplete = async(studentId, courseId, certificateURL) => {
  try {
    const response = await fetch(`${API_URL}/api/student-courses/${studentId}/complete/${courseId}?certificateUrl=${certificateURL}`, {
      method: "POST",
      credentials: "include",
      
    });
    
    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      return { success: false, message: data.message || "Error completing course." };
    }
    } catch (error) {
      console.log("error is :", error);
      // if (error.response) {
      //   // Extract the backend error message

      //   setMessage(error.response.data.message || "An error occurred");
      // } else {
      //   setMessage("Something went wrong. Please try again.");
      // }
      console.error("Error:", error);
      throw error;
    }

    
}


